import React from 'react'

type Props = {
    children: React.ReactNode;
    isEstadoActivo: boolean
}

const stylesTop = { marginTop: "-20px" };

export const GridViewProducts:React.FC<Props> = ({children, isEstadoActivo}:Props) => {
  return (
    <div className="ps-tabs" style={stylesTop}>
      <div className={isEstadoActivo ? `ps-tab active` : "ps-tab"}>
        <div className="ps-shopping-product">{children}</div>
      </div>
    </div>
  )
}
